import dayjs from 'dayjs';
import type { EquipmentPositionSummary } from '../interfaces/MachinePosition.types';
import type { MachinePositionHistory } from 'app/cross-cutting-concerns/communication/interfaces/am-api-graphql';

export const mapMachinePositionHistoryToEquipmentPositionSummary = (
  history: MachinePositionHistory
): EquipmentPositionSummary => ({
  id: history.id,
  address: history.address ?? undefined,
  placeId: history.placeId ?? undefined,
  latitude: history.latitude,
  longitude: history.longitude,
  accuracy: history.accuracy,
  enteredAt: history.enteredAt,
  exitedAt: history.exitedAt ?? undefined,
  createdAt: history.createdAt,
  updatedAt: history.updatedAt,
});

export const POSITION_HISTORY_DATE_FORMAT = 'DD/MM/YYYY';

export const formatPositionHistoryDate = (date: string): string => dayjs(date).format(POSITION_HISTORY_DATE_FORMAT);

export const getPositionHistoryDurationInDays = (summary: EquipmentPositionSummary): number =>
  summary.exitedAt
    ? dayjs(summary.exitedAt).diff(dayjs(summary.enteredAt), 'day')
    : dayjs().diff(dayjs(summary.enteredAt), 'day');

export const sortPositionSummariesByEnteredAtDesc = (
  summaries: EquipmentPositionSummary[]
): EquipmentPositionSummary[] =>
  [...summaries].sort(
    (summaryA, summaryB) => dayjs(summaryB.enteredAt).valueOf() - dayjs(summaryA.enteredAt).valueOf()
  );

export const sortPopoverSummaries = (summaries: EquipmentPositionSummary[]): EquipmentPositionSummary[] =>
  [...summaries].sort((summaryA, summaryB) => {
    const summaryAIsCurrent = !summaryA.exitedAt;
    const summaryBIsCurrent = !summaryB.exitedAt;

    if (summaryAIsCurrent && !summaryBIsCurrent) return -1;
    if (!summaryAIsCurrent && summaryBIsCurrent) return 1;

    return dayjs(summaryB.enteredAt).valueOf() - dayjs(summaryA.enteredAt).valueOf();
  });
